export default {
  identification: 'Identification',
  country: 'Country',
  department: 'Department',
  description: 'Description',
  charge: 'Charge',
  screen: 'Screen'
}
